export default "__VITE_ASSET__CBXz0EsK__"